export const userHeaderCells = [
    { field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "email", title: "EMAIL", width: 150 },
	{ field: "firstName", title: "FIRST NAME", width: 150 },
	{ field: "lastName", title: "LAST NAME", width: 150 },
	{ field: "phone", title: "PHONE NUMBER", sortable: false, width: 100 },
	{ field: "role", title: "ROLE", sortable: false, width: 180 },
	{ field: "", title: "ACTION", sortable: false, width: 60 },
]

